<template>
  <a-spin :spinning="spinning" style="min-height: 320px">
    <div
      v-for="ipAddress in ipAddresses"
      :key="ipAddress.id"
      style="margin: 4px; width: 32px; height: 32px; display: inline-block"
    >
      <a-tooltip :title="ipAddress.source ? ipAddress.source.name : ''">
        <a-card
          :bordered="false"
          :body-style="bodyStyle(ipAddress.online, ipAddress.allocated)"
          @click="showDetail(ipAddress)"
        >
          <source-icon
            v-if="ipAddress.source"
            :source-type="ipAddress.source_type"
            style="color: #fff"
          ></source-icon>
          <div v-else style="color: #ffffff; user-select: none">
            {{ ipAddress.name | displayName }}
          </div>
        </a-card>
      </a-tooltip>
    </div>

    <network-device-drawer ref="networkDeviceDrawer"></network-device-drawer>
    <storage-drawer ref="storageDrawer"></storage-drawer>
    <server-drawer ref="serverDrawer"></server-drawer>
    <os-drawer ref="osDrawer"></os-drawer>
    <middleware-drawer ref="middlewareDrawer"></middleware-drawer>
    <database-drawer ref="databaseDrawer"></database-drawer>
    <hypervisor-drawer ref="hypervisorDrawer"></hypervisor-drawer>
  </a-spin>
</template>

<script>
import { getIPSubnetIPAddressList } from '@/api/ip-subnet'
import SourceIcon from '@/components/icon/SourceIcon'
import { grayColor, greenColor } from '@/utils/const'
import DatabaseDrawer from '@/components/drawer/DatabaseDrawer'
import HypervisorDrawer from '@/components/drawer/HypervisorDrawer'
import MiddlewareDrawer from '@/components/drawer/MiddlewareDrawer'
import NetworkDeviceDrawer from '@/components/drawer/NetworkDeviceDrawer'
import OSDrawer from '@/components/drawer/OSDrawer'
import ServerDrawer from '@/components/drawer/ServerDrawer'
import StorageDrawer from '@/components/drawer/StorageDrawer'

export default {
  name: 'IPAddressList',
  components: {
    SourceIcon,
    DatabaseDrawer,
    HypervisorDrawer,
    MiddlewareDrawer,
    NetworkDeviceDrawer,
    'os-drawer': OSDrawer,
    ServerDrawer,
    StorageDrawer
  },
  props: {
    subnetId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      spinning: false,
      ipAddresses: []
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.spinning = true
      getIPSubnetIPAddressList(this.subnetId)
        .then(res => {
          this.ipAddresses = res.data.data
        })
        .finally(() => {
          this.spinning = false
        })
    },
    bodyStyle (online, allocated) {
      return {
        background: online ? greenColor : grayColor,
        cursor: online && allocated ? 'pointer' : 'default',
        padding: 0,
        height: '32px',
        borderRadius: '8px',
        lineHeight: '32px',
        textAlign: 'center'
      }
    },
    showDetail (ipAddress) {
      if (ipAddress.online) {
        switch (ipAddress.source_type) {
          case 'network_device':
            this.$refs.networkDeviceDrawer.show(ipAddress.source_id)
            break
          case 'storage':
            this.$refs.storageDrawer.show(ipAddress.source_id)
            break
          case 'server':
            this.$refs.serverDrawer.show(ipAddress.source_id)
            break
          case 'os':
            this.$refs.osDrawer.show(ipAddress.source_id)
            break
          case 'middleware':
            this.$refs.middlewareDrawer.show(ipAddress.source_id)
            break
          case 'database':
            this.$refs.databaseDrawer.show(ipAddress.source_id)
            break
          case 'hypervisor':
            this.$refs.hypervisorDrawer.show(ipAddress.source_id)
            break
        }
      }
    }
  },
  filters: {
    displayName (value) {
      return value.includes('.') ? value.split('.')[3] : value
    }
  }
}
</script>

<style lang="less">
.ant-badge-status-dot {
  width: 12px;
  height: 12px;
  border-radius: 0;
}
</style>
